
export default {
    name: 'AdminLayout',
    data() {
        return {
            firstLevel: "level-1",
            secondLevel: "level-2",
            secondLevelTop: "level-2 mt-4",
        }
    },
    methods: {
        createUrl: function (path) {
            return process.env.url.manegement + path;
        },
        bodyToggleClass: function (event) {
            document.body.classList.toggle("mobile-menu-active");
        },
        logout: function () {
            this.setCookies("Authorization", null, { expires: -1 })
            window.location.href = process.env.url.manegement + "/Logout.aspx";
        },
        setCookies: function (name, value, props) {
            props = props || {}
            var exp = props.expires

            if (typeof exp == "number" && exp) {
                var d = new Date()
                d.setTime(d.getTime() + exp * 1000)
                exp = props.expires = d
            }

            if (exp && exp.toUTCString) {
                props.expires = exp.toUTCString()
            }
            value = encodeURIComponent(value)
            var updatedCookie = name + "=" + value

            for (var propName in props) {
                updatedCookie += "; " + propName
                var propValue = props[propName]
                if (propValue !== true) { updatedCookie += "=" + propValue }
            }

            document.cookie = updatedCookie;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/shared/layout/admin-layout/admin-layout.js